'use client'

import Button from '@/components/ui/Button'
import { signInWithOAuth } from '@/utils/saas/auth-helpers/client'
import { type Provider } from '@supabase/supabase-js'
import { SiGithub } from '@icons-pack/react-simple-icons'
import { useState, JSX } from 'react'

type OAuthProviders = {
  name: Provider
  displayName: string
  icon: JSX.Element
}

export default function OauthSignIn() {
  const oAuthProviders: OAuthProviders[] = [
    {
      name: 'github',
      displayName: 'GitHub',
      icon: <SiGithub color="#61DAFB" size={24} />,
    },
    /* Add desired OAuth providers here */
  ]
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (e: React.SubmitEvent<HTMLFormElement>) => {
    console.log('handleSubmit() - e=', e)
    setIsSubmitting(true) // Disable the button while the request is being handled
    await signInWithOAuth(e)
    setIsSubmitting(false)
  }

  return (
    <div className="mt-8">
      {oAuthProviders.map((provider) => (
        <form
          key={provider.name}
          className="pb-2"
          onSubmit={(e) => {
            // NOTE: Intentionally not awaited.
            void handleSubmit(e)
          }}
        >
          <input type="hidden" name="provider" value={provider.name} />
          <Button
            id="oauth-sign-in-button"
            variant="slim"
            type="submit"
            className="w-full"
            loading={isSubmitting}
          >
            <span className="mr-2">{provider.icon}</span>
            <span>{provider.displayName}</span>
          </Button>
        </form>
      ))}
    </div>
  )
}
